import { APP } from 'Constant';

export const CONTAINER = 'APP';

// Actions
export const SET_INITIAL_STATE = `${APP}/${CONTAINER}/SET_INITIAL_STATE` as const;
export const GET_DEVICE = `${APP}/${CONTAINER}/GET_DEVICE` as const;
export const GET_DEVICE_SUCCESS = `${APP}/${CONTAINER}/GET_DEVICE_SUCCESS` as const;
export const GET_DEVICE_FAILED = `${APP}/${CONTAINER}/GET_DEVICE_FAILED` as const;
export const GET_SUBSCRIPTION = `${APP}/${CONTAINER}/GET_SUBSCRIPTION` as const;
export const GET_SUBSCRIPTION_SUCCESS = `${APP}/${CONTAINER}/GET_SUBSCRIPTION_SUCCESS` as const;
export const GET_SUBSCRIPTION_FAILED = `${APP}/${CONTAINER}/GET_SUBSCRIPTION_FAILED` as const;
export const UPDATE_STORAGE = `${APP}/${CONTAINER}/UPDATE_STORAGE` as const;
export const SET_INITIAL_LOAD_DONE = `${APP}/${CONTAINER}/SET_INITIAL_LOAD_DONE` as const;
export const CHANGE_COLOR = `${APP}/${CONTAINER}/CHANGE_COLOR` as const;
export const CHANGE_CASE_SIZE = `${APP}/${CONTAINER}/CHANGE_CASE_SIZE` as const;
export const SET_ATOMIC_ID = `${APP}/${CONTAINER}/SET_ATOMIC_ID` as const;
export const SET_HARDWARE_ONLY = `${APP}/${CONTAINER}/SET_HARDWARE_ONLY` as const;
export const SET_PAYMENT = `${APP}/${CONTAINER}/SET_PAYMENT` as const;
export const GO_TO_BASKET = `${APP}/${CONTAINER}/GO_TO_BASKET` as const;
export const TRIGGER_TRACKING = `${APP}/${CONTAINER}/TRIGGER_TRACKING` as const;
export const TOGGLE_ACCORDION_ITEM = `${APP}/${CONTAINER}/TOGGLE_ACCORDION_ITEM` as const;

// HTML
export const LOADING_CONTAINER = 'loading-container';
export const HTML_CONTAINER_ID_PREFIX = 'stone-ddp';
export const TEXT_HEADER_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-text-header`;
export const IMAGE_GALLERY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-image-gallery`;
export const OPTION_PICKER_COLOR_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-color-option-picker`;
export const OPTION_PICKER_CASE_SIZE_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-case-size-option-picker`;
export const OPTION_PICKER_HARDWARE_ONLY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-hardware-only-option-picker`;
export const OPTION_PICKER_PAYMENT_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-payment-option-picker`;
export const DELIVERY_DATE_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-delivery-date`;
export const OFFER_SUMMARY_CARD_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-offer-summary-card`;
export const STICKY_PRICE_BAR_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-sticky-price-bar`;
export const BENEFITS_HARDWARE_ONLY_FALSE_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-hardware-only-false`;
export const BENEFITS_HARDWARE_ONLY_TRUE_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-hardware-only-true`;
export const BENEFITS_PAYMENT_MONTHLY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-payment-monthly`;
export const BENEFITS_PAYMENT_ONETIME_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-payment-onetime`;
export const TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-technical-details-accordion`;
export const ERROR_NOTIFICATION_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-error-notification`;

// Miscellaneous
export const MTAN_PAGE = '/shop/authentifizierung.html?btype=multicardContract';
export const TRACKING_PAGENAME = 'produktdetails';
export const ONE_NUMBER_TARIFF_OPTION = '302060';
